@if (messages$ | async; as messages) {
    <div class="quick-bet__modal-dialog">
        <div class="quick-bet__modal-dialog-header">{{ sitecore.quickBetModalDialog.BetNotPlaced }}</div>
        @for (error of messages; track error) {
            <div class="quick-bet__modal-dialog-message" [innerHtml]="error"></div>
        }
        <div>
            <div class="quick-bet__modal-dialog-button-container">
                <div class="btn quick-bet__modal-dialog-button btn-primary" (click)="close()">
                    {{ sitecore.quickBetModalDialog.OkButton }}
                </div>
            </div>
        </div>
    </div>
}
